function newState() {
  return {
    navbarComponents: [],
  }
}

/**
 * @namespace Stores
 * @category Stores
 * @module navbar-store
 * */
export default {
  namespaced: true,
  state: newState(),
  getters: {
    navbarComponents(state) {
      return state.navbarComponents
    },
  },
  mutations: {
    setNavbarComponents(state, navbarComponents) {
      state.navbarComponents = navbarComponents
    },
    resetStore(state) {
      let s = newState()
      for (let x in s) {
        state[x] = s[x]
      }
    },
  },
  actions: {
    resetStore({ commit }) {
      commit('resetStore')
    },
    /**
     * Only used by Ecoconduite
     * @todo Refactor/Remove
     * @param {*} param0
     * @param {*} navbarComponents
     */
    setNavbarComponents({ commit }, navbarComponents) {
      commit('setNavbarComponents', navbarComponents)
    },
  },
}
